import { useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import { RiArrowUpSLine } from "react-icons/ri";
import { Tooltip } from "react-tooltip";
import { IoInformationCircleOutline } from "react-icons/io5";
import "../../textinput/textInput.css";

function ParentIdInput({
    setIcontoolsField,
    domainIndex,
    parentId,
    isLocked,
    domainCount,
}) {
    const [isValid, setValid] = useState(true);
    const [getInputValue, setInputValue] = useState("");
    const [getInvalidInputMessage, setInvalidInputMessage] = useState("");
    const regex = /^[0-9]$/;

    const handleChange = (input) => {
        const value = input.target.value;
        if (value.match(regex) && value <= domainCount - 1) {
            setValid(true);
            setIcontoolsField(domainIndex, "parent_id", value);
        } else {
            /* 
            if the input is not valid the input field will display the getInputValue instead of the state value
            this is to avoid having the state variable be set to a invalid value and also still allow input of invalid values
            blocking any invalid input leads to bad UX
            */
            setInputValue(value || "");
            setValid(false);
            if (value <= domainCount - 1) {
                setInvalidInputMessage("domain with ID is not defined");
            }
            setInvalidInputMessage("not a valid domain ID");
        }
    };

    const handleIncrementDecrement = (operation) => {
        let nextValue;
        switch (operation) {
            case "-":
                nextValue = parentId - 1;
                break;
            case "+":
                nextValue = parseInt(parentId) + 1;
                break;
            default:
                console.log("Incrementing or decrementing failed.");
                break;
        }

        if (nextValue.toString().match(regex) && nextValue <= domainCount - 1) {
            setIcontoolsField(domainIndex, "parent_id", nextValue);
        }
    };

    /*
     catch any except allowed characters from being inputted
     Note: pasting illegal characters into the input field is still possible
    */
    const handleKeyDown = (e) => {
        const normalAllowedCharacters = [
            "Tab",
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
        ];

        if (normalAllowedCharacters.includes(e.key)) return;
        if (e.key.match(regex)) return;
        e.preventDefault();
    };

    return (
        <div className={"input-container"}>
            <Tooltip id={"info-domain-tooltip"} />
            <div className={"label-container"}>
                <p>parent_id</p>
                <IoInformationCircleOutline
                    data-tooltip-id={"info-domain-tooltip"}
                    data-tooltip-place={"right"}
                    data-tooltip-content={"Parent grid ID for each domain"}
                />
            </div>
            <div className={"domain-input-field-container"}>
                <input
                    value={isValid ? parentId : getInputValue}
                    inputMode={"decimal"}
                    className={"text-input domain-text-input valid-" + isValid}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    readOnly={domainIndex === 0 ? true : isLocked}
                    placeholder={parentId}
                />
                <div className={"increment-decrement-container"}>
                    <button
                        onClick={domainIndex === 0 ? null : () => handleIncrementDecrement("+")}
                        className={"domain-input-increment"}
                    >
                        <RiArrowUpSLine />
                    </button>
                    <button
                        onClick={domainIndex === 0 ? null : () => handleIncrementDecrement("-")}
                        className={"domain-input-decrement"}
                    >
                        <RiArrowDownSLine />
                    </button>
                </div>
            </div>
            {!isValid && (
                <p className={"invalid-input-message"}>{getInvalidInputMessage}</p>
            )}
        </div>
    );
}

export default ParentIdInput;
